module.exports = __webpack_public_path__ + "./assets/signupBanner__214e4fc0038061e3c44b94dc57eea5a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/signupBanner.png
// module id = 1006
// module chunks = 37